import {DialogButtonInterface, DialogButtonTypesEnum, DialogConfigInterface} from '../../../shared/components/dialog';

export class ConfirmationData {
    private readonly config: DialogConfigInterface;

    public caption: string;
    public question: string;

    constructor(caption: string, question: string, buttons?: DialogButtonInterface[], disabledCloseBtn?: boolean) {
        this.caption = caption;
        this.question = question;

        this.config = {
            process: {
                loading: false,
                finished: false,
                failed: false,
                failedMessage: '',
                succeedMessage: ''
            },
            buttons: buttons ?? [
                {
                    type: DialogButtonTypesEnum.Cancel
                },
                {
                    type: DialogButtonTypesEnum.Confirm
                }
            ],
            buttonsDisabled: false,
            buttonsHidden: false,
            disabledCloseBtn
        };
    }

    getConfig(): DialogConfigInterface {
        return this.config;
    }
}
